import React from 'react';
import s from './marker.module.css';
// import {withRouter} from 'react-router-dom';

const Marker = React.memo(({ name, relativeTime, key, big, onClick }) => {
	return (
		<div
			onClick={onClick}
			className={`hint hint--html hint--info hint--top ${s.container} ${big ? s.containerBig : ''}`}
			style={{ position: 'absolute', transform: 'translate(-50%, -50%)' }}
			onDoubleClick={e => e.stopPropagation()}
			onMouseDown={e => e.stopPropagation()}
			onPointerDown={e => e.stopPropagation()}
			onTouchStart={e => e.stopPropagation()}
		>
			{big ? (
				<div className={s.containerOpened}>
					<span className={s.text}>{name}</span>
					<span>{relativeTime}</span>
				</div>
			) : (
				<div className={s.containerClosed} />
			)}
			{/* <Tooltip title={name || ''} placement="top">
        <Marker style={{ color: '#0069A7', fontSize: '40px' }} />
      </Tooltip> */}
		</div>
	);
});

export default Marker;
